"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHelpMenu = void 0;
var lodash_1 = require("lodash");
var icons_1 = __importDefault(require("../../../assets/icons"));
var Link_logic_1 = require("../../atoms/Link/Link.logic");
var HelpMenu_static_1 = require("./HelpMenu.static");
function useHelpMenu(_a) {
    var documentationUrl = _a.documentationUrl, faqUrl = _a.faqUrl;
    var newTabIcon = icons_1.default.newTab;
    var helpItems = (0, lodash_1.compact)([
        documentationUrl && {
            title: HelpMenu_static_1.localText.documentation,
            icon: icons_1.default.documentation,
            rightIcon: (0, Link_logic_1.isExternalUrl)(documentationUrl) ? newTabIcon : undefined,
            url: documentationUrl,
        },
        faqUrl && {
            title: HelpMenu_static_1.localText.faq,
            icon: icons_1.default.information,
            rightIcon: (0, Link_logic_1.isExternalUrl)(faqUrl) ? newTabIcon : undefined,
            url: faqUrl,
        },
    ]);
    return {
        helpItems: helpItems,
    };
}
exports.useHelpMenu = useHelpMenu;
